<mat-toolbar
  [ngClass]="!layout.lockAppbar && layout.isOnMap ? 'collapseToolbar' : 'expandToolbar'"
  class="toolbar"
  id="fs_main-toolbar"
>
  <div class="invisibleBar" *ngIf="!layout.lockAppbar && layout.isOnMap"></div>
  <div class="toolbarSections">
    <div class="sectionOne" align="start">
      <sn-layout-appbar-nav-button *ngIf="navButtonVisible$ | async" [@snZoomIn] [@snZoomOut]>
      </sn-layout-appbar-nav-button>
      <span class="subtitle-three" [class.pushed]="layout.pushTitle">
        {{ layout.isOnMap ? ('common.axonFusus' | t) : (title$ | async) }}
      </span>

      <div class="callSign" *ngIf="areCallsignsAvailable$ | async">
        <mat-chip
          [class.call-sign-chip]="!twoRow"
          *ngIf="layout.isOnMap"
          (click)="openCallSignDialog()"
          [matTooltip]="'map.appbar.editCallSign' | t"
        >
          <span class="appbar-callsign-text"> {{ 'common.callSign' | t }}: {{ callSign }} </span>
        </mat-chip>
      </div>

      <div>
        <sn-icon-button
          *ngIf="layout.isOnMap && !layout.lockAppbar"
          [class.lock-appbar-button]="!twoRow"
          [matTooltip]="'map.appbar.lockToolbar' | t"
          (click)="toggleCollapsed(true)"
        >
          <sn-icon fontIcon="Icon_FususUnlockIcon" fontSet="fs"></sn-icon>
        </sn-icon-button>

        <sn-icon-button
          *ngIf="layout.isOnMap && layout.lockAppbar"
          [class.lock-appbar-button]="!twoRow"
          [matTooltip]="'map.appbar.unlockToolbar' | t"
          (click)="toggleCollapsed(false)"
        >
          <sn-icon fontIcon="Icon_FususLockIcon" fontSet="fs"></sn-icon>
        </sn-icon-button>
      </div>
    </div>
  </div>

  <div class="toolbarSections">
    <ng-container *ngIf="searchActive$ | async as searchActive">
      <ng-template *ngIf="searchActive === 'top'" [ngTemplateOutlet]="searchTmpl"> </ng-template>
    </ng-container>
  </div>
  <div class="headlessIFrameContainer" style="display: none"></div>

  <div class="toolbarSections actionList" align="end">
    <sn-layout-appbar-actions
      [items]="actions$ | async"
      [componentOrTemplate]="actionsComponentOrTemplate$ | async"
      [componentOrTemplateConfig]="actionsComponentOrTemplateConfig$ | async"
    >
    </sn-layout-appbar-actions>
  </div>
  <fs-debug-panel-button></fs-debug-panel-button>
</mat-toolbar>

<ng-template #searchTmpl>
  <div class="sn-layout-appbar__search-section">
    <sn-searchbar
      id="fs__appbar-search-bar"
      [value]="searchValue$ | async"
      (valueChange)="onSearch($event)"
      [options]="searchOptions$ | async"
      [clearOnNavEnd]="false"
      (search)="onSearchSubmit($event)"
      (click)="onSearchClick()"
    >
    </sn-searchbar>
  </div>
</ng-template>
